module.exports = function() {
    $(".form-container").on("keydown",
        ".bootstrap-select",
        function(e) {
            var code = e.which;
            if (code === 9) {
                var indx = $(this).find('.dropdown-menu li.selected').index();
                //console.log("Index: " + indx);
                $(this).find('.dropdown-toggle').click();
                //console.log("click triggered on dropdown-toggle");
                //console.log("length: " + $(this).find('ul.dropdown-menu a').eq(indx).html());
                $(this).find('ul.dropdown-menu a').eq(indx).click();
                console.log($(this).parent().attr("class"));
                console.log($(this).parent().next().attr("class"));
                $(this).parent().next().focus();
            }
        });
};